import { createContainer } from 'shared-components/unstated'

/**
 * The signed-in reader's own phone state, for the comment phone pill's popover ("Your device",
 * apps/android-authority/docs/your-device-plan.md). Optional: an app that never provides it (SoundGuys)
 * gets `viewerHasPhone: null` — no "Add your phone" link — and no refresh callback.
 */
export interface ViewerDevicesState {
  /** True/false once the reader's devices have loaded; null = unknown (signed out, loading, or
   *  no provider). Only `false` draws "Add your phone to your profile". */
  viewerHasPhone: boolean | null
  /** Called after the widget changed the reader's devices (Hide on comments), so the app's own
   *  device state refetches. */
  onDevicesChanged?: () => void
  /** The site that does not verify phones, in the popover's "Self-declared, <siteName> doesn't
   *  verify…" line; absent = "we". */
  siteName?: string
}

export const ViewerDevicesContext = createContainer<ViewerDevicesState, ViewerDevicesState>(
  initial => ({
    viewerHasPhone: initial?.viewerHasPhone ?? null,
    onDevicesChanged: initial?.onDevicesChanged,
    siteName: initial?.siteName,
  })
)
